// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__15yj5","messages":"Chat_messages__23mSB","dateDivider":"Chat_dateDivider__1GTuD"};